import React from 'react';

interface ReasonCardProps {
  title: string;
  subtitle: string;
  img: string;
  description: string;
}

export default function ReasonCard({
  title = '',
  subtitle = '',
  img = '',
  description = '',
}: ReasonCardProps) {
  return (
    <div className="flex flex-col justify-center items-center py-12 px-8 bg-white rounded-xl shadow-outline-blue gap-6">
      <div className="flex flex-col">
        <img
          className="w-[150px] h-[150px] rounded-full mx-auto"
          src={img}
          alt={title}
        />
        <h3 className="mt-3 font-bold text-xl lg:text-2xl text-neutral-600 text-center">
          {title}
        </h3>
        <span className="text-lg lg:text-xl text-neutral-300 text-center">
          {subtitle}
        </span>
      </div>
      <div className="">
        <p className="text-base lg:text-lg text-neutral-500">{description}</p>
      </div>
    </div>
  );
}
